/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import React, { Dispatch, SetStateAction } from "react";
import { Map } from "@vis.gl/react-google-maps";

import { IBranch } from "@/app/[lang]/locations/helpers";
import Markers from "./Markers";

function GoogleMapComponent({
  branches,
  center,
  zoom,
  setMapZoom,
  // setMapCenter,
  moreDetails,
  multiMarkers,
  nearestMarkers = {},
}: {
  branches: IBranch[];
  zoom: number;
  center: { lat: number; lng: number };
  setMapZoom?: (zoom: number) => void;
  setMapCenter?: Dispatch<SetStateAction<{ lat: number; lng: number }>>;
  moreDetails: string;
  multiMarkers?: boolean;
  nearestMarkers?: any;
}) {
  if (!branches || !center) {
    return <div>no data</div>;
  }

  return (
    <Map
      zoom={zoom}
      center={center}
      mapId={process.env.NEXT_PUBLIC_MAP_ID}
      mapTypeControl={false}
      scaleControl={false}
      streetViewControl={false}
      rotateControl={false}
      fullscreenControl={false}
      onZoomChanged={(data) => setMapZoom && setMapZoom(data?.detail?.zoom || 9)}
    >
      <Markers
        branches={branches}
        moreDetails={moreDetails}
        mapZoom={zoom}
        multiMarkers={multiMarkers}
        nearestMarkers={nearestMarkers}
        // setMapZoom={setMapZoom}
        // setMapCenter={setMapCenter}
      />
    </Map>
  );
}

export default React.memo(GoogleMapComponent);
